/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThirdPartyNetwork } from '../../models/third-party-network';
import { ThirdPartyNetworkApiRespModel } from '../../models/third-party-network-api-resp-model';

export interface ApiMasterThirdPartyNetworkEditPost$Params {
      body?: ThirdPartyNetwork
}

export function apiMasterThirdPartyNetworkEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterThirdPartyNetworkEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ThirdPartyNetworkApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterThirdPartyNetworkEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThirdPartyNetworkApiRespModel>;
    })
  );
}

apiMasterThirdPartyNetworkEditPost.PATH = '/api/Master/ThirdPartyNetwork/Edit';
